"use client";

// eslint-disable-next-line no-restricted-imports
import { RedirectType, redirect, usePathname } from "next/navigation";
import { getCurrentSafeLanguage } from "/i18n-config";

// Note that `app/not-found/page.tsx`
// is necessary for this page to render.

// this will redirect to custom i18n supported notfound page
export default function NotFoundPage() {
  const pathName = usePathname();
  const lang = pathName.split(`/`)[1];
  const currentLanguage = getCurrentSafeLanguage(lang);
  return redirect(`/${currentLanguage}/not-found`, RedirectType.replace);
}
